module.exports = __webpack_public_path__ + "static/media/house-on-hill.7be56dc0.jpg";